import { render, staticRenderFns } from "./index.vue?vue&type=template&id=196e731e&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/brisk/brisk-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('196e731e')) {
      api.createRecord('196e731e', component.options)
    } else {
      api.reload('196e731e', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=196e731e&", function () {
      api.rerender('196e731e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/platforms/apps/index.vue"
export default component.exports